module.exports = {
      id: "icon-copy-usage",
      viewBox: "0 0 19.657 19.657",
      url: "/" + "sprite-a5f842c290447276eba09a9bdedabd59.svg#icon-copy",
      toString: function () {
        return this.url;
      }
    }